import * as React from 'react';
import { SVGProps } from 'react';

const IconDownloadSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 11v-1H1v1h10zM5.499 1v6.293L3.14 4.928l-.707.708L6 9.208l3.54-3.539-.707-.707L6.5 7.293V1h-1z" />
  </svg>
);
export default IconDownloadSizeXs;
